"use client";

import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import DorasIcon from "@/components/marketing/dorasicon";
import { IUserData } from "@/types";
import { cn } from "@/lib/utils";
import {
    BORDER_RADIUS_OPTIONS,
    SHADOW_OPTIONS,
} from "./blocks/utils/block-style-classes";

interface DorasBrandingProps {
    account: IUserData;
    theme: IUserData["chosen_theme"];
}

export default function DorasBranding({ account, theme }: DorasBrandingProps) {
    if (account.settings.branding) {
        return null;
    }

    return (
        <div
            id="doras-branding-root"
            className="relative z-50 mx-auto mt-auto flex w-full max-w-2xl flex-1 flex-col gap-4 px-3 pt-6 md:px-6"
        >
            {account.affiliate == null ? (
                <a
                    href="https://doras.to"
                    className="group mx-auto my-16 flex w-fit flex-col items-center gap-2"
                >
                    <div
                        className={cn(
                            "mx-auto flex w-fit items-center gap-3 border border-user-tertiary-color bg-background px-6 py-4 text-foreground transition-all duration-200 group-hover:scale-105",
                            BORDER_RADIUS_OPTIONS[
                                theme.profile.design.corner_radius
                            ].class
                        )}
                        style={{
                            background: theme.profile.colors.primary,
                            color: theme.profile.colors.primary_text,
                        }}
                    >
                        <DorasIcon
                            className="h-8 w-8"
                            color={theme.profile.colors.primary_text}
                        />
                        <Label
                            variant="headingtoggle"
                            className="cursor-pointer text-2xl font-bold"
                            style={{ color: theme.profile.colors.primary_text }}
                        >
                            Doras.to
                        </Label>
                        <Separator
                            orientation="vertical"
                            className="h-6"
                            style={{
                                background: theme.profile.colors.primary_text,
                            }}
                        />
                        <Label
                            variant="headingtoggle"
                            className="mx-auto cursor-pointer text-center font-bold"
                            style={{
                                color: theme.profile.colors.primary_text,
                            }}
                        >
                            Create your profile today
                        </Label>
                    </div>
                </a>
            ) : (
                <a
                    id="affiliate-doras-branding-root"
                    href={`https://doras.to?aff=${account.affiliate}`}
                    className={cn(
                        "group relative mx-auto my-16 flex w-full flex-col items-center gap-2 overflow-hidden border border-user-tertiary-color py-3 transition-all duration-300 hover:scale-110",
                        BORDER_RADIUS_OPTIONS[
                            theme.profile.design.corner_radius
                        ].class,
                        SHADOW_OPTIONS[theme.profile.design.shadow].class,
                        "text-secondary-primary-color bg-user-primary-color"
                    )}
                >
                    <img
                        id="affiliate-doras-branding-img"
                        src={account.pic}
                        className="absolute -bottom-5 -right-6 size-36 -rotate-12"
                        alt="Doras Logo"
                    />
                    <Label
                        id="affiliate-doras-branding-label"
                        variant="headingtoggle"
                        className="z-50 mx-auto cursor-pointer text-center text-xl font-bold text-inherit"
                        style={{
                            color: theme.profile.colors.primary_text,
                        }}
                    >
                        Join {account.displayname} on
                    </Label>
                    <div className="z-50 mx-auto flex w-fit items-center gap-3 text-foreground transition-all duration-200 group-hover:scale-105">
                        <img
                            src="https://cdn.doras.to/doras/icon-white.svg"
                            className="h-8 w-8"
                            alt="Doras Logo"
                        />
                        <Label
                            variant="headingtoggle"
                            className="cursor-pointer text-2xl font-bold text-inherit"
                            id="affiliate-doras-branding-label"
                            style={{
                                color: theme.profile.colors.primary_text,
                            }}
                        >
                            Doras
                        </Label>
                    </div>
                </a>
            )}
        </div>
    );
}
